import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=f10a0888&scoped=true&lang=pug&"
import script from "./ImagePreview.vue?vue&type=script&lang=js&"
export * from "./ImagePreview.vue?vue&type=script&lang=js&"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=f10a0888&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10a0888",
  null
  
)

component.options.__file = "ImagePreview.vue"
export default component.exports